import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { defineMessages, FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import { Link, Redirect } from "react-router-dom";
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import GlobalHelper from '../common/GlobalHelper.jsx';
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import LoadingSpinner from '../common/spinner/loading.component.jsx';
import { INTEGRATION_KEY, PAYMENT_INTEGRATION_KEYS } from '../state/integration/Constants';
import IntegrationCard from "./integrationcard.component.jsx";
import * as IntegrationConstants from "./IntegrationConstants.jsx";
import Integrations from "./Integrations.jsx";

const queryString = require('query-string')

const messages = defineMessages({
    "d-tools_title": {
        id: 'integration.d-tools.title',
        defaultMessage: 'D-tools System Integrator 2016 +',
    },
    "d-tools_description": {
        id: 'integration.d-tools.description',
        defaultMessage: 'Catalog import and project creation on quote approval.',
    },
    "quickbooks_title": {
        id: 'integration.quickbooks.title',
        defaultMessage: 'Quickbooks',
    },
    "quickbooks_description": {
        id: 'integration.quickbooks.description',
        defaultMessage: 'Export approved quotes to Acomba. Import product list.',
    },
    "outlook_title": {
        id: 'integration.outlook.title',
        defaultMessage: 'Outlook',
    },
    "outlook_description": {
        id: 'integration.outlook.description',
        defaultMessage: 'Link your employee calendar and enable your customers to book themselves a product or service event',
    },
    "lightspeed_title": {
        id: 'integration.lightspeed.title',
        defaultMessage: 'Lightspeed Retail',
    },
    "lightspeed_description": {
        id: 'integration.lightspeed.description',
        defaultMessage: 'Sync your product catalog, inventory and contacts in real time. Export your proposal into a Sale once approved',
    },
    "stripe_title": {
        id: 'integration.stripe.title',
        defaultMessage: 'Stripe',
    },
    "stripe_description": {
        id: 'integration.stripe.description',
        defaultMessage: 'Take online payment from the invoice and get paid faster. Invoice balance gets updated automatically.',
    },
    "paysafe_title": {
        id: 'integration.paysafe.title',
        defaultMessage: 'Paysafe',
    },
    "paysafe_description": {
        id: 'integration.paysafe.description',
        defaultMessage: 'Take credit card and direct debit payment from the invoice to get paid faster. Invoice balance gets updated automatically.',
    },
    "custom_smtp_title": {
        id: 'integration.custom_smtp.title',
        defaultMessage: 'Custom SMTP server',
    },
    "custom_smtp_description": {
        id: 'integration.custom_smtp.description',
        defaultMessage: 'Send emails from your own email provider and email with your domain.',
    },
})


class IntegrationListing extends Component {

    constructor(props, context) {
        super(props, context)

        const uri = queryString.parse(this.props.location.search)
        this.state = {
            integrations: [],
            integrationKeys: [],
            integrationToggles: {},
            integrationLockedToggles: {},
            locations: [],
            headers: [],
            rows: [],
            loading: false,
            uri: uri,
            redirect: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshListing()
    }


    refreshListing() {
        //Todo: remove after finishing v2 migration, keep only 'nylas'
        const nylasVersion = [INTEGRATION_KEY.NYLAS, INTEGRATION_KEY.NYLASV3]

        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/integration-configurations').then(r => {
            
            r.data = r.data.filter(it => !nylasVersion.includes(it.attributes.integrationKey))
            let integrationToggles = {}
            let integrationLockedToggles = {}
            let integrationKeys = {}
            const enabledPaymentIntegrations = r.data.filter(i => PAYMENT_INTEGRATION_KEYS.includes(i.attributes.integrationKey))
                .filter(i => i.attributes.enabled)
            for (let i in r.data) {
                const conf = r.data[i]
                integrationToggles[conf.id] = conf.attributes.enabled
                integrationLockedToggles[conf.id] = conf.attributes.locked
                integrationKeys[conf.attributes.integrationKey] = true
                if (PAYMENT_INTEGRATION_KEYS.includes(conf.attributes.integrationKey) && enabledPaymentIntegrations.length > 0 &&
                    !enabledPaymentIntegrations.some(i => i.id === conf.id || i.attributes.integrationKey === conf.attributes.integrationKey)) {
                    conf.attributes.locked = true
                }
            }
            const newState = {
                integrationKeys: Object.keys(integrationKeys),
                integrations: r.data,
                integrationToggles: integrationToggles,
                integrationLockedToggles: integrationLockedToggles,
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            }
            if (this.state.uri.open) {
                const search = r.data.filter(i => i.attributes.integrationKey === this.state.uri.open)
                if (search.length > 0) {
                    newState.redirect = <Redirect to={{ pathname: '/integrations/edit/' + search[0].id }} />
                }
            }
            this.setState(newState)
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.integrations.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="listing.integrations.list.headers.location_label"
                defaultMessage="Location"
            />,
            <FormattedMessage
                id="listing.integrations.list.headers.last_update_label"
                defaultMessage="Last update"
            />,
            <FormattedMessage
                id="listing.integrations.list.headers.city_label"
                defaultMessage="Enabled"
            />,
            (GlobalHelper.isSuperUserLoggedIn() &&
                <>
                    <FormattedMessage
                        id="listing.integrations.list.headers.locked"
                        defaultMessage="Locked"
                    />
                    <Icon value="lock" className="lock" />
                </>)
        ]
    }

    toggleSwitch(integrationId) {
        return function () {
            let integrationToggles = this.state.integrationToggles
            integrationToggles[integrationId] = !integrationToggles[integrationId]
            AppContext.getApiClient().patch('/integration-configurations/' + integrationId, {
                enabled: integrationToggles[integrationId],
            }).then(r => {
                this.refreshListing()
            })
        }.bind(this)
    }

    toggleLockedSwitch(integrationId) {
        return function () {
            let integrationLockedToggles = this.state.integrationLockedToggles
            integrationLockedToggles[integrationId] = !integrationLockedToggles[integrationId]
            AppContext.getApiClient().patch('/integration-configurations/' + integrationId, {
                locked: integrationLockedToggles[integrationId],
            })
            this.setState({
                integrationLockedToggles: integrationLockedToggles
            })
        }.bind(this)
    }

    getIntegrationConfigNameToDisplay(integrationConfig) {
        const integrationName = Integrations.getIntegrationNameFromKey(integrationConfig.attributes.integrationKey)
        switch (integrationConfig.attributes.integrationKey) {
            case INTEGRATION_KEY.PIPEDRIVE:
                return `${integrationName} (${integrationConfig.attributes.configuration.userFullName})`
            default: return integrationName || item.attributes.integrationKey
        }
    }

    row(item) {
        const locationIds = !!item.attributes.locationIds ? item.attributes.locationIds : []
        const locationNames = locationIds?.length > 0 ?
            locationIds.map(id => {
                return GlobalHelper.getLocationById(id)?.attributes?.name || ""
            }).join(", ") : <FormattedMessage
                id="listing.integrations.list.all_location_label"
                defaultMessage="All"
            />
        return [
            <div>
                <Link
                    to={"/integrations/edit/" + item.id}>{this.getIntegrationConfigNameToDisplay(item)}</Link>
                {(item.attributes.configuration && item.attributes.configuration.testMode === true) &&
                    <div><small className="text-danger">
                        <Icon value={'exclamation'} />
                        <FormattedMessage
                            id="listing.integrations.list.linked_to_test_account_label"
                            defaultMessage="Linked to a test account"
                        /></small></div>
                }

                {(item.attributes.errorMessage) &&
                    <div>
                        <small className="text-danger">
                            <Icon value={'exclamation'} />
                            {item.attributes.errorMessage}
                        </small>
                    </div>

                }

            </div>,
            locationNames,
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(item.attributes.updatedAt)} />,
            <Toggle
                defaultChecked={item.attributes.enabled}
                icons={this.props.enableLinkIcons}
                onChange={this.toggleSwitch(item.id)}
                disabled={item.attributes.locked}
            />,
            (GlobalHelper.isSuperUserLoggedIn() &&
                <Toggle
                    defaultChecked={item.attributes.locked}
                    icons={this.props.enableLinkIcons}
                    onChange={this.toggleLockedSwitch(item.id)}
                />)
        ]
    }


    requiresFlag(integration) {
        return !integration.requiredFlag || (integration.requiredFlag && GlobalHelper.getAccountFlag(integration.requiredFlag))
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
            smallLine={true}
        />
        let elements = []
        if (this.state.loading) {
            elements.push(<LoadingSpinner key={elements.length} />)
        } else {
            for (let index in IntegrationConstants.details) {
                const integration = IntegrationConstants.details[index]
                if (this.state.integrationKeys.includes(integration.key) && !integration.multi) {
                    continue
                }
                if (this.state.integrationKeys.filter(key => integration.incompatibleWith.includes(key)).length > 0) {
                    continue
                }
                if (integration.hide) {
                    continue
                }
                if (integration.hideOnProduction && GlobalHelper.isEnvProduction()) {
                    continue
                }

                if (this.requiresFlag(integration)) {
                    elements.push(
                        <div className={'col-4 px-3 d-flex'} key={elements.length}>
                            <IntegrationCard
                                key={elements.length}
                                imgPath={integration.logo}
                                imgClassName={"pl-3 py-3"}
                                title={integration.name}
                                description={integration.description}
                                integrationKey={integration.key}
                                enableLinkIcons={false}
                                category={integration.category}
                                authConnect={integration.authConnect}
                            />
                        </div>
                    )
                }

            }
        }
        return (
            <div>
                {this.state.redirect}
                <MyAccountTabs />
                {list}
                <div className="row py-3">
                    {elements}
                </div>
            </div>
        );
    }
}

export default injectIntl(IntegrationListing);



// WEBPACK FOOTER //
// ./src/integration/listing.component.jsx